var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaimondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#0FAF59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6668L5.89977 11.0415C5.62267 10.6952 5.48412 10.522 5.44689 10.3132C5.40968 10.1045 5.47981 9.89413 5.62007 9.47331L6.24027 7.61274C6.60695 6.5127 6.79028 5.96269 7.22677 5.6481C7.66324 5.3335 8.24301 5.3335 9.40255 5.3335H14.5975C15.757 5.3335 16.3368 5.3335 16.7733 5.6481C17.2098 5.96269 17.3931 6.5127 17.7598 7.61274L18.3799 9.47331C18.5203 9.89413 18.5903 10.1045 18.5531 10.3132C18.5159 10.522 18.3773 10.6952 18.1003 11.0415L12 18.6668ZM12 18.6668L14.9167 9.50016M12 18.6668L9.08335 9.50016M14.9167 9.50016L18.25 10.3335M14.9167 9.50016L13.6667 6.16683M14.9167 9.50016H9.08335M9.08335 9.50016L10.3333 6.16683M9.08335 9.50016L5.75002 10.3335",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaimondIcon);
export default __webpack_public_path__ + "static/media/DaimondIcon.b615cb3bde80a24595a90a3d238bea5f.svg";
export { ForwardRef as ReactComponent };